import React, { Component } from 'react';
import './Item.css'
import SWTWageItemListModal from '../../workdoc/SWTWageItemListModal'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    this.refs.wageItemPopup.openPopup()
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.settings.show&&newProps.settings.show!==this.props.settings.show) {
  //     this.refs.wageItemPopup.getWrappedInstance().openPopup()
  //   }
  // }

  onItemSelect() {

  }

  render() {
    let {messages} = this.props
    return(
  		<div>
        <h3>{messages['Damage Config']}</h3>
        <SWTWageItemListModal 
          mode='table'
          type='damage'
          ref={'wageItemPopup'}
          onSelect={this.onItemSelect.bind(this)} 
          onHide={()=>{}}
        />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu11.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu11/Item.js